import { useQuery } from 'react-query';
import { getCategories, getCategory } from 'services/api/category';

export const useGetCategory = ({
  uuid,
  token,
  enabled,
}: {
  uuid: string;
  token?: string;
  enabled?: boolean;
}) => {
  return useQuery(['getCategory', { uuid, token }], getCategory(uuid, token), {
    staleTime: 1000 * 60 * 5,
    enabled,
  });
};

export const useGetCategories = ({
  uuid,
  token,
}: {
  uuid?: string;
  token?: string;
}) => {
  return useQuery(
    ['getCategories'],
    getCategories({
      token,
      uuid,
    }),
    {
      enabled: !!token && !!uuid,
      staleTime: 1000 * 60 * 5,
    },
  );
};
